module.exports = __webpack_public_path__ + "img/S1051430.e568e761.jpg";